// import React from 'react';
import List from '../layout/list'
import Accordion from '../parts/accordion'
import Select from '../parts/form/Select';
import ResetAndSubmit from '../parts/ResetAndSubmit';
import axios from 'axios';
import * as Common from '../../common';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ForcedLogout from '../function/ForcedLogout'

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

/**
 * ページ名
 */
const pageType="property";

/**
 * ページ名（日本語）
 */
const pageTypeJa="物件";

/**
 * 検索結果に表示する項目名リスト
 */
 const resultItemName:Array<any>=[
    {
        'slug':'property_code',
        'name':'物件コード'
    },
    {
        'slug':'property_name',
        'name':'物件名'
    },
    {
        'slug':'owner_name',
        'name':'施主名'
    },
    {
        'slug':'m_prefecture_id',
        'name':'都道府県'
    },
    {
        'slug':'search_address',
        'name':'住所'
    },
]




/**
 * トークン情報
 */
let token:String=''

//export部分
function Property() {

    //ページタイトルを変更
    document.title = `物件一覧 | ${Common.SITE_NAME}`;

    /**
     * Resultで選択しているID
     */
    const [selectedItemInResult, setSelectedItemInResult] = useState<any>(null)

    /**
     * 検索条件を編集するコンポーネントをリセットするのに使う
     * 値が変わるとリセットされる
     */
    const [valueForComponentReset,setValueForComponentReset]=useState<boolean>(false)

    /**
     * 検索条件
     */
    const [resultCondition,setResultCondition]=useState<any>({
        /**
         * 昇順かどうか　true:昇順、false:降順
         */
        order:true,

        /**
         * どのプロパティで並び替えるのか
         */
        sort: 'property_code',

        /**
         * 1ページに表示する項目数　固定
         */
        limit:10,

        /**
         * 表示するページ数
         */
        page:1,
    })

    /**
     * 型：入力情報
     */
    interface typeInputInfo{
        /**
         * 物件コード
         */
        property_code: any,

        /**
         * 物件名
         */
        property_name: any,

        /**
         * 施主名
         */
        owner_name: any,

        /**
         * 都道府県ID
         */
        m_prefecture_id: any,

        /**
         * 住所
         */
        search_address: any,

    }

    /**
     * 検索条件
     */
    const [inputInfo,setInputInfo]=useState<typeInputInfo>({
        property_code: '',
        property_name: '',
        owner_name: '',
        m_prefecture_id: '',
        search_address: '',
    })

    const history = useHistory();

    /**
     * 検索結果に表示する情報
     */
    const [resultObject,setResultObject]=useState<Object|null>(null)

    //tokenに、Cookieから取得したtoken情報を格納
    token=Common.getCookie('cookieToken')

    if(token!=='not found'){
        //tokenがあったとき
        //tokenをcookieに入れ、有効期限を延長
        document.cookie = "cookieToken=" + token + ";max-age=" + Common.LOGIN_EXPIRE_TIME
    }else{
        //tokenがないとき
        //ログインページに遷移
        history.push('/login')
    }

    /**
     * フォームをリセット
     */
    const onReset=()=>{
        //inputInfoのコピーを作る
        const inputInfoTemp:any=Object.assign({},inputInfo)

        //値を全て''にする
        for(let key in inputInfoTemp){
            inputInfoTemp[key]=''
        }
        
        //inputInfoに値を設定
        setInputInfo(Object.assign({},inputInfoTemp))

        //上記だと入力用コンポーネントの値はリセットされないため
        //valueForComponentResetの値を変更し、各コンポーネントをリセット
        const temp = valueForComponentReset
        setValueForComponentReset(!temp)

        //検索結果のラジオボタンの選択状態をリセット
        setSelectedItemInResult(null)

        //この次onSearchを行うが、ここに書くと値が更新されていないので
        //下記のuseEffectを使用
    }

    //inputInfoに変更があれば実行される
    useEffect(()=>{
        //変わったinputInfoで、再検索
        onSearch()  
    },[valueForComponentReset])

    /**
     * 検索する
     */
    const onSearch=()=>{

        /**
         * axiosで送るparams
         */
        const paramsTemp:any=Object.assign({},inputInfo)

        //paramsTempのコピーを作る
        const params=Object.assign({},paramsTemp)

        //キーが空の要素を消す
        Object.keys(paramsTemp).forEach((key:any)=>{
            if(paramsTemp[key]===''){
                delete params[key]
            }
        })

        //paramsの特定のキーの値にlikeをつける
        const keysOfLike=['property_code','property_name','owner_name','search_address']
        keysOfLike.forEach((key:string)=>{
            if(params[key]){
                params[key]=`like:${params[key]}`
            }
        })

        // paramsの特定のキーの値にeqをつける
        const keysOfEq=['m_prefecture_id']
        keysOfEq.forEach((key:string)=>{
            if(params[key]){
                params[key]=`eq:${params[key]}`
            }
        })

        //paramsのステータスが見積もり中でない場合、
        //有効期限、予定工期、納期、請求予定日を消す
        if(params.project_status!==1){
            delete params.expiration_date
        }

        //paramsに検索条件を追加
        params.limit=resultCondition.limit
        params.sort=`${resultCondition.order?'':'-'}${resultCondition.sort}`
        params.page=resultCondition.page

        //axiosの前に、他端末がログインしていたらログアウト
        ForcedLogout(history,token)
        
        //APIで情報取得
        axios.get(`${Common.API_DOMAIN()}/api/api/v1/m_properties`,{
            headers:{
                Authorization: `Bearer ${token}`
            },
            params:params,
        })
        .then((response)=>{
            setResultObject(Object.assign({},response))
        })
        .catch((error)=>{
            console.error({error})
            //エラーコードが401のとき（＝トークン有効期限切れのとき）
            if({error}.error.response.status==='401'){
                //強制ログアウト
                ForcedLogout(history, token)
            }
        })
    }

    /**
     * result.tsxでresultConditionが変わった場合発火する
     */
    const onChangeResultCondition=(value:any)=>{
        //resultConditionを、本コンポーネントでも変更
        setResultCondition(value)

        //この次onSearchを行うが、ここに書くと値が更新されていないので
        //下記のuseEffectを使用
    }

    //resultConditionに変更があれば実行される
    useEffect(()=>{
        //変わったresultConditionで、再検索
        onSearch()  
    },[resultCondition])

    /**
     * 検索ボタンを押したとき
     */
    const onSubmit=(e?:React.FormEvent)=>{
        //submit処理を取り消し
        if(e){
            e.preventDefault();
        }

        //resultConditionのページを１にリセット
        setResultCondition({ ...resultCondition, page: 1})
        
        //ここで、resultConditionの変更により
        //useEffectが動き、検索が実行される
    }

    return(
        <List
            token={token}
            onChangeResultCondition={(value:any)=>{
                onChangeResultCondition(value)
            }}
            resultCondition={resultCondition}
            resultObject={resultObject}
            pageType={pageType}
            pageTypeJa={pageTypeJa}
            resultItemName={resultItemName}
            selectedItemInResult={selectedItemInResult}
            onChangeselectedItemInResult={(value:any)=>{
                setSelectedItemInResult(value)
            }}
        >

            <form className="content__form" onReset={onReset} onSubmit={onSubmit}>
                <Accordion title="検索条件" isOpen="true" classForIdentification={pageType+'__accordion'} accordionType={pageType + '__search-condition'}>
                    <ul className="form__list">
                        <li className="form__item">
                            <dl className="form__item-inner">
                                <dt className="form__item-ttl">
                                    物件コード
                                </dt>
                                <dd className="form__item-input">
                                    <div className="form__item-input-inner form__item-input-inner--input">
                                        <input type="text" value={inputInfo.property_code} onChange={(e:any) => {setInputInfo({ ...inputInfo, property_code: e.target.value });}} />
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li className="form__item">
                            <dl className="form__item-inner">
                                <dt className="form__item-ttl">
                                    物件名
                                </dt>
                                <dd className="form__item-input">
                                    <div className="form__item-input-inner form__item-input-inner--input">
                                        <input type="text" value={inputInfo.property_name} onChange={(e:any) => {setInputInfo({ ...inputInfo, property_name: e.target.value });}} />
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li className="form__item">
                            <dl className="form__item-inner">
                                <dt className="form__item-ttl">
                                    施主名
                                </dt>
                                <dd className="form__item-input">
                                    <div className="form__item-input-inner form__item-input-inner--input">
                                        <input type="text" value={inputInfo.owner_name} onChange={(e:any) => {setInputInfo({ ...inputInfo, owner_name: e.target.value });}} />
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        
                        <li className="form__item">
                            <dl className="form__item-inner">
                                <dt className="form__item-ttl">
                                    都道府県
                                </dt>
                                <dd className="form__item-input">
                                    <div className="form__item-input-inner form__item-input-inner--select">
                                        <select value={inputInfo.m_prefecture_id} onChange={(e:any) => {setInputInfo({ ...inputInfo, m_prefecture_id: e.target.value });}}>
                                            <option value="">　</option>
                                            {
                                                Common.PREFECTURES.map((data)=>{
                                                    return(
                                                        <option value={data.code} key={data.code}>{data.name}</option>
                                                    )
                                                })
                                            }
                                        </select>  
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li className="form__item">
                            <dl className="form__item-inner">
                                <dt className="form__item-ttl">
                                    住所
                                </dt>
                                <dd className="form__item-input">
                                    <div className="form__item-input-inner form__item-input-inner--input">
                                        <input type="text" value={inputInfo.search_address} onChange={(e:any) => {setInputInfo({ ...inputInfo, search_address: e.target.value });}} />
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        
                    </ul>
                </Accordion>
                
                <ResetAndSubmit></ResetAndSubmit>
            </form>



        </List>
    );
}

export default Property;